/**
 * Canonical public host is gglife.app (apex). Alias hosts must not stay in the
 * address bar — they split SEO, cookies, and auth, and Namecheap HTTP-only
 * forwards cannot terminate HTTPS.
 */

export const CANONICAL_HOST = "gglife.app";

export const ALIAS_HOSTS = [
  "gglife.gg",
  "www.gglife.gg",
  "www.gglife.app",
] as const;

export function isAliasHost(hostname: string): boolean {
  const host = hostname.toLowerCase().replace(/\.$/, "");
  return (ALIAS_HOSTS as readonly string[]).includes(host);
}

/** Absolute https://gglife.app URL, or null when the host is already canonical. */
export function canonicalUrlForHost(href: string, hostname: string): string | null {
  if (!isAliasHost(hostname)) return null;
  const url = new URL(href);
  url.protocol = "https:";
  url.hostname = CANONICAL_HOST;
  url.port = "";
  return url.toString();
}

/** Browser entry: replace onto the canonical host. Returns true if navigating away. */
export function redirectAliasHostToCanonical(): boolean {
  if (typeof window === "undefined") return false;
  const dest = canonicalUrlForHost(window.location.href, window.location.hostname);
  if (!dest) return false;
  window.location.replace(dest);
  return true;
}
